import { render, staticRenderFns } from "./ModalEnableExtraFeatures.vue?vue&type=template&id=2b7596aa"
import script from "./ModalEnableExtraFeatures.vue?vue&type=script&lang=js"
export * from "./ModalEnableExtraFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports